module.exports = __webpack_public_path__ + "static/media/Bring_logo.c7293e06.svg";